import { LegalPage } from '@/features/legal/components/legal-page'

export default function TermsPage() {
  return <LegalPage documentKey="terms" />
}
